import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IDefaultPaginatedResponse } from "../../models/DefaultResponse";
import { ICategoryGroup } from "../../models/CategoryGroup/CategoryGroup";
import { CategoryGroupQueryKeys } from "./keys";

export interface IUseCategoryGroupsProps {
  searchTerm?: string;
  pageNumber?: number;
  itemsPerPage?: number;
  includeDeleted?: boolean;
}

export default function useCategoryGroups({
  searchTerm,
  pageNumber,
  itemsPerPage,
  includeDeleted,
}: IUseCategoryGroupsProps) {
  const { get } = useApiHelper();
  const params: Record<string, string> = {};

  if (searchTerm) params.searchTerm = searchTerm;
  if (pageNumber !== undefined) params.pageNumber = pageNumber.toString();
  if (itemsPerPage !== undefined) params.itemsPerPage = itemsPerPage.toString();
  if (includeDeleted) params.includeDeleted = includeDeleted.toString();
  const queryString = new URLSearchParams(params).toString();

  const categoryGroups = useQuery({
    queryKey: [...CategoryGroupQueryKeys.all(), queryString],
    queryFn: () =>
      get<IDefaultPaginatedResponse<ICategoryGroup[]>>(`/part/category-groups?${queryString}`),
  });

  return {
    categoryGroups,
  };
}
